import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { includes } from 'ramda';

import api from 'api/api';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import AUTH from 'consts/auth';

const { connect, selectors, actions } = StoreProvider;

interface TokenCheckerProps {
  children: React.ReactElement;
  token: string;
  signOut: () => void;
  signIn: (data: object) => void;
}

const TokenChecker = ({
  children,
  token,
  signOut,
  signIn,
}: TokenCheckerProps) => {
  const [tokenIsCheked, setTokenIsChecked] = useState(false);
  const [intervalChecker, setIntervalChecker] = useState(0);
  const tokenIntervalInMinutes = 60000;

  const checkToken = () => {
    const isProduction = process.env.NODE_ENV === 'production';
    return api.resources
      .refreshToken({ token: token || (Cookies.get(AUTH.TOKEN) as string) })
      .then(({ data }) => {
        setTokenIsChecked(true);
        Cookies.set(AUTH.TOKEN, `${data.token}`, {
          path: '/',
          domain: isProduction ? '.deeptrue.com' : 'localhost',
        });
        signIn(data);
      })
      .catch((err) => {
        if (err.response) {
          if (includes(err.response.status, [400, 401])) {
            Cookies.remove(AUTH.TOKEN, {
              path: '/',
              domain: isProduction ? '.deeptrue.com' : 'localhost',
            });
            setTokenIsChecked(true);
            signOut();
          }
        }
      });
  };

  useEffect(() => {
    const deeptrueAuthToken = Cookies.get(AUTH.TOKEN);
    if (!token && !deeptrueAuthToken) {
      clearTimeout(intervalChecker);
      setIntervalChecker(0);
      setTokenIsChecked(true);
    } else if (!tokenIsCheked) {
      checkToken();
    } else {
      setIntervalChecker(
        // TODO - types.
        setTimeout(checkToken, tokenIntervalInMinutes * 15) as any
      );
    }
    // eslint-disable-next-line
  }, [token]);

  return tokenIsCheked ? children : null;
};

export default connect(
  (state) => ({
    token: selectors.authSelectors.token(state),
  }),
  {
    signOut: actions.authActions.signOut,
    signIn: actions.authActions.signIn,
  }
)(TokenChecker);
